import type {
  BookingCoverageCard,
  BookingCoverageService,
} from '@/types/api/queries';

import { Label } from '@/components/ui/label';
import { RadioGroupItem } from '@/components/ui/radio-group';

import { cn } from '@/lib/utils';

type CoverageCandidateProps = {
  value: string;
  candidate: BookingCoverageCard | BookingCoverageService;
  details: string[];
};

export const CoverageCandidate = (props: CoverageCandidateProps) => {
  const { value, candidate, details } = props;

  return (
    <Label
      htmlFor={value}
      className={cn(
        'flex w-full cursor-pointer items-center gap-3 rounded-md border p-3 font-normal',
        !candidate.eligible && 'cursor-not-allowed opacity-60',
      )}
    >
      <RadioGroupItem
        value={value}
        id={value}
        disabled={!candidate.eligible}
      />
      <span className="grid gap-0.5">
        <span className="font-medium">{candidate.name}</span>
        {details.length > 0 && (
          <span className="text-muted-foreground text-xs">
            {details.join(' · ')}
          </span>
        )}
        {!candidate.eligible && candidate.error_message && (
          <span className="text-destructive text-xs">
            {candidate.error_message}
          </span>
        )}
      </span>
    </Label>
  );
};
